export const pt = {
  nav: {
    home: 'Início',
    services: 'Serviços',
    about: 'Sobre Nós',
    contact: 'Contato',
    bookNow: 'Agende Agora',
  },
  hero: {
    tagline: 'Limpeza Confiável e Detalhada',
    bookNow: 'Agende Agora',
    getQuote: 'Faça um Orçamento',
  },
  services: {
    title: 'Nossos Serviços',
    subtitle: 'Limpeza profissional adaptada às suas necessidades',
    house: {
      title: 'Limpeza de Casas',
      desc: 'Limpeza completa para toda a sua casa, garantindo que cada canto brilhe.',
    },
    apartment: {
      title: 'Limpeza de Apartamentos',
      desc: 'Limpeza eficiente e minuciosa projetada especificamente para a vida em apartamento.',
    },
    office: {
      title: 'Limpeza de Escritórios',
      desc: 'Mantenha um espaço de trabalho impecável e produtivo com nossa limpeza confiável.',
    },
    benefits: {
      title: 'Por que nos escolher?',
      deep: 'Limpeza Profunda',
      eco: 'Produtos Ecológicos',
      staff: 'Equipe Treinada e Confiável',
      flexible: 'Horários Flexíveis',
    },
    learnMore: 'Saiba Mais',
  },
  about: {
    title: 'Sobre a Lucy Cleaning',
    storyTitle: 'Nossa História',
    founderLabel: 'Fundadora',
    founderName: 'Lucy',
    story:
      'Fundada com paixão por espaços impecáveis, a Lucy Cleaning Services tem se dedicado a trazer brilho e conforto para casas e escritórios em Marshfield e região. Acreditamos que um ambiente limpo é a base de uma vida feliz e saudável.',
    mission:
      'Nossa missão é fornecer serviços de limpeza confiáveis, detalhados e de confiança que superem as expectativas, permitindo que nossos clientes se concentrem no que mais importa para eles.',
    values: {
      title: 'Nossos Valores',
      trust: 'Confiança',
      trustDesc: 'Tratamos seu espaço com o máximo respeito e segurança.',
      quality: 'Qualidade',
      qualityDesc: 'Padrões rigorosos em cada varrida e esfregada.',
      care: 'Cuidado',
      careDesc: 'Suave com seus pertences, implacável com a sujeira.',
      detail: 'Atenção aos Detalhes',
      detailDesc: 'Notamos as pequenas coisas para que você não precise.',
    },
  },
  testimonials: {
    title: 'O que nossos clientes dizem',
    reviews: [
      {
        name: 'Sarah Jenkins',
        text: 'A Lucy e sua equipe são verdadeiros salva-vidas. Minha casa nunca esteve tão impecável. A atenção aos detalhes é incomparável!',
      },
      {
        name: 'Michael Rodriguez',
        text: 'Profissionais, pontuais e minuciosos. Usamos para o nosso escritório e a diferença é da noite para o dia. Recomendo muito.',
      },
      {
        name: 'Emily Chen',
        text: 'Adoro chegar em casa depois que a Lucy Cleaning esteve aqui. Cheira a fresco e parece perfeito. Os produtos ecológicos são um grande diferencial.',
      },
    ],
  },
  contact: {
    title: 'Entre em Contato',
    subtitle:
      'Adoraríamos ouvir de você. Solicite um orçamento ou tire uma dúvida.',
    info: 'Informações de Contato',
    address: 'Marshfield, Massachusetts',
    phone: '+1 (781) 309-0991',
    email: 'lucycleaningservices0@gmail.com',
    hours: 'Seg-Sex: 8h - 18h',
    form: {
      name: 'Seu Nome',
      phone: 'Número de Telefone',
      message: 'Como podemos ajudar?',
      submit: 'Enviar Mensagem',
      success:
        'Obrigado! Sua mensagem foi enviada. Entraremos em contato em breve.',
    },
  },
  booking: {
    title: 'Agende uma Limpeza',
    subtitle: 'Agende seu próximo serviço de limpeza em poucos cliques.',
    form: {
      serviceType: 'Tipo de Serviço',
      selectService: 'Selecione um serviço...',
      date: 'Data Preferencial',
      time: 'Horário Preferencial',
      name: 'Nome Completo',
      phone: 'Número de Telefone',
      address: 'Endereço do Serviço',
      notes: 'Instruções Especiais ou Notas',
      submit: 'Confirmar Agendamento',
      successTitle: 'Pedido de Agendamento Recebido!',
      successMsg:
        'Obrigado por escolher a Lucy Cleaning Services. Entraremos em contato em breve para confirmar os detalhes do seu agendamento.',
      bookAnother: 'Agendar Outro Serviço',
    },
  },
  footer: {
    tagline: 'Trazendo brilho para o seu espaço.',
    quickLinks: 'Links Rápidos',
    contact: 'Fale Conosco',
    followUs: 'Siga-nos',
    rights: 'Todos os direitos reservados.',
  },
  beforeAfter: {
    title: 'Antes e Depois',
    subtitle:
      'Veja a transformação. Arraste o controle para revelar a diferença que nossa equipe faz.',
    before: 'Antes',
    after: 'Depois',
    items: [
      { label: 'Cozinha — Limpeza Profunda' },
      { label: 'Banheiro Renovado' },
      { label: 'Sala de Estar Revitalizada' },
    ],
  },
}
